import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import useMedia from 'use-media';
import Section from '../../../containers/Section';
import Header, { HeaderVariant } from '../../Header';
import Icon, { IconType } from '../../Icon';
import { GatsbyImage } from 'gatsby-plugin-image';

interface CustomersProps {
  title?: string;
  description?: string;
  badges?: any;
}

const CustomersVote: React.FC<CustomersProps> = props => {
  const { title, description, badges } = props;

  const bgImage = useStaticQuery(graphql`
    query {
      stroke: file(relativePath: { eq: "index/stroke.svg" }) {
        relativePath
        publicURL
      }
    }
  `);

  const isDesktop = useMedia({ minWidth: '767px' });

  return (
    <Section className="lg:px-4 max-w-7xl mx-auto">
      <div className="text-center pt-20 pb-28 md:pt-20 md:pb-[240px]">
        <div
          style={{
            backgroundImage: isDesktop
              ? `url(${bgImage.stroke.publicURL})`
              : `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='24' ry='24' stroke='%236366F1' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='87' stroke-linecap='square'/%3e%3c/svg%3e")`,
          }}
          className="content-border rounded-[24px] bg-no-repeat bg-center max-w-screen-lg mx-auto relative pt-10 pb-[90px] px-10 md:p-[80px]"
        >
          <div className="rounded-full absolute mx-auto inset-x-0 top-[-25px] h-14 w-14 shadow-xl flex items-center justify-center bg-white mb-3 z-10">
            <Icon iconType={IconType.star} className="ml-1" />
          </div>

          <p className="text-2xl font-semibold  m-auto whitespace-nowrap max-w-min text-gradient bg-gradient-to-r from-indigo-1 to-blue-1 mb-3">
            {title}
          </p>
          <Header
            variant={HeaderVariant.h3}
            className="md:mb-18 m-auto text-3xl max-w-[443px]"
          >
            {description && description}
          </Header>
          <div className="flex flex-wrap m-auto justify-center max-w-[99%] md:max-w-screen-sm bg-white md:bg-transparent absolute inset-x-0 ">
            {badges?.map((badge, index) => {
              return (
                badge?.svg?.gatsbyImageData ? <GatsbyImage imgStyle={{
                  objectFit: "contain",
                }} className="px-1 md:px-8 bg-white pt-2 max-w-[81px] md:max-w-[160px]" image={badge?.svg?.gatsbyImageData} alt={badge?.text} /> : <img
                  className="px-1 md:px-8 bg-white pt-2 w-[81px] md:w-[160px]"
                  key={index}
                  src={badge?.svg?.url}
                  alt={badge?.text}
                />
              );
            })}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default CustomersVote;
